import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const mainContent: SxStyle = {
  width: '100%',
};

export const role: SxStyle = {
  justifyContent: 'flex-end',
};

export const description: SxStyle = {
  width: 'fill-available',
  flexDirection: 'column',
  gap: (p) => p.spacing(0.25),

  '& > .MuiGrid2-root': {
    m: 0,
    p: 0,
  },
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[400],
};
